/**
 * Componente: Dashboard
 * Panel principal del vendedor
 */

import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuthContext } from '../contexts/AuthContext';
import mockDataService from '../services/mockDataService';
import { formatCurrency } from '../utils/formatters';
import './Dashboard.css';

const Dashboard = () => {
  const { user, logout } = useAuthContext();
  const navigate = useNavigate();

  const stats = mockDataService.getStatistics(user?.id);

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const menuItems = [
    { 
      title: '💰 Realizar Pago', 
      description: 'Cobrar productos a estudiantes',
      path: '/payment',
      color: '#667eea'
    },
    { 
      title: '💳 Recargar Saldo', 
      description: 'Agregar saldo a carnets',
      path: '/recharge',
      color: '#48bb78'
    },
    { 
      title: '🔍 Consultar Saldo', 
      description: 'Ver saldo de estudiante',
      path: '/balance',
      color: '#ed8936'
    },
    { 
      title: '📊 Transacciones', 
      description: 'Historial completo',
      path: '/transactions',
      color: '#9f7aea'
    },
    { 
      title: '🛍️ Mis Productos', 
      description: 'Gestionar catálogo',
      path: '/products',
      color: '#38b2ac'
    }
  ];

  return (
    <div className="dashboard-container">
      <header className="dashboard-header">
        <div>
          <h1>💳 {user?.nombre}</h1>
          <p>{user?.email}</p>
        </div>
        <button onClick={handleLogout} className="logout-btn">
          Cerrar Sesión
        </button>
      </header>

      <div className="dashboard-stats">
        <div className="stat-card">
          <div className="stat-value">{stats.totalTransactionsToday}</div>
          <div className="stat-label">Transacciones Hoy</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{stats.totalPaymentsToday}</div>
          <div className="stat-label">Pagos Hoy</div>
        </div>
        <div className="stat-card">
          <div className="stat-value">{formatCurrency(stats.totalVentasToday)}</div>
          <div className="stat-label">Total Vendido</div>
        </div>
      </div>

      <div className="dashboard-menu">
        {menuItems.map((item, index) => (
          <div
            key={index}
            className="menu-item"
            onClick={() => navigate(item.path)}
            style={{ borderLeftColor: item.color }}
          >
            <div className="menu-item-title">{item.title}</div>
            <div className="menu-item-description">{item.description}</div>
          </div>
        ))}
      </div>

      <div className="dashboard-info">
        <p>📱 <strong>Modo Simulador NFC:</strong> {process.env.REACT_APP_ENABLE_SIMULATOR === 'true' ? 'Activado' : 'Desactivado'}</p>
        <p>🔒 Todos los datos están encriptados y almacenados localmente</p>
      </div>
    </div>
  );
};

export default Dashboard;
